// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const SETUP = '@organizationConfig/SETUP';
export const CHECK = '@permission/CHECK';
export const CAPSULE = '@capsule/CAPSULE';
export const SETDEPARTMENT = '@currentDepartment/SETDEPARTMENT';
